module.exports = __webpack_public_path__ + "img/md6bid0.d175604d.png";